export const localeToPath = (locale: string) => {
  return locale === 'en' ? '' : `/${locale}`;
};
